import {Injectable} from '@angular/core';
import {formatDate} from '@angular/common';
import moment from 'moment-timezone';
import {isDate} from 'moment';


@Injectable({ providedIn: 'root'})
export class DateTimeService{

  ptBrToStringOptions = {year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hour12: false, minute:'2-digit', second:'2-digit'};

  public tolocalDateTime(givenDateStringUtc) {
    if (!givenDateStringUtc) return null;
    var givenDate = new Date(givenDateStringUtc);

    var currentDate = new Date();
    var offset = -(currentDate.getTimezoneOffset() / 60);
    var hours = givenDate.getHours();
    hours += offset;

    var resultDate = new Date(givenDate.getTime());
    resultDate.setHours(hours);
    return resultDate;
  };

  public toLocalDateTimePickerFormat(givenDateStringUtc){
    if (!givenDateStringUtc) return null;
    let localDate = new Date(givenDateStringUtc);

    const dd = String(localDate.getDate()).padStart(2, '0');
    const MM = String(localDate.getMonth() + 1).padStart(2, '0');
    const yyyy = localDate.getFullYear();
    let hh = String(localDate.getHours()).padStart(2, '0');;
    let mm = String(localDate.getMinutes()).padStart(2, '0');;
    return (`${yyyy}-${MM}-${dd}T${hh}:${mm}`);

  }

  public formatDateTimePickerFormat(givenDate: Date){
    return formatDate(givenDate,'yyyy-MM-ddTHH:mm', 'pt-BR');
  }

  public getLocalTimeStamp() {
    return formatDate(new Date(), 'yyyMMddHHmmss', 'pt-BR');
  }

  public toLocalStringDateTime(givenDateStringUtc: string, completeHour:boolean=true){
    if (!givenDateStringUtc)
      return;
    let localDate = this.tolocalDateTime(givenDateStringUtc);
    //return localDate.toLocaleDateString("pt-BR", this.ptBrToStringOptions);
    if (completeHour)
      return formatDate(localDate,'dd/MM/yyyy HH:mm:ss.SSS',"pt-BR");
    else
      return formatDate(localDate,'dd/MM/yyyy HH:mm:ss',"pt-BR");
  }

  public formatBrDateTime(givenDate:Date, completeHour:boolean=true) {
    if (completeHour)
      return formatDate(givenDate,'dd/MM/yyyy HH:mm:ss',"pt-BR");
    else
      return formatDate(givenDate,'dd/MM/yyyy HH:mm',"pt-BR");
  }



  public toUTC(date: Date) {
    if (!date) return null;
    const currentTimeZone = moment.tz.guess();
    const dateUtc = moment.tz(date, currentTimeZone);
    return dateUtc.utc().format();
  }

  public toLocalISOStringDateTime(givenDateStringUtc: string, completeHour:boolean=true){
    if (!givenDateStringUtc)
      return;
    let localDate = this.tolocalDateTime(givenDateStringUtc);
    //return localDate.toLocaleDateString("pt-BR", this.ptBrToStringOptions);
    if (completeHour)
      return formatDate(localDate,'yyyy-MM-ddTHH:mm:ss.SSS',"pt-BR");
    else
      return formatDate(localDate,'yyyy-MM-ddTHH:mm:ss',"pt-BR");
  }

  public toISOStringDateTime(givenDateString: string){
    if (!givenDateString)
      return;

    let date = new Date(givenDateString);
    return formatDate(date,'yyyy-MM-ddTHH:mm',"pt-BR");
  }

  public static dateDiff(currentDate, pastDate) {
    const past = moment(pastDate, 'DD/MM/YYYY HH:mm:ss');
    const current = moment(currentDate, 'DD/MM/YYYY HH:mm:ss');

    const diff = current.diff(past);
    const duration = moment.duration(diff);
    const hour = Math.floor(duration.asHours());

    return ('0'+hour).slice(-2) + moment.utc(diff).format(":mm:ss");
  }
}
